import React from 'react'
import { Header, Logo, Title, Week } from '../../Header/style'

const header = props => {
    return (
        <Header
            backgroundImage={`img/concept/${props.concept}/kiosk/${props.kioskName}/mono-header.png?_=9edb01b`}
            mode="kiosk"
        >
            <Logo
                src={
                    props.isMonoKiosk
                        ? `img/concept/${props.concept}/kiosk/${props.kioskName}/logo.png?_=9edb01b`
                        : `img/concept/${props.concept}/logo.png?_=9edb01b`
                }
                isMonoKiosk={props.isMonoKiosk}
            />
            {props.date && <Week>{props.date}</Week>}
            <Title
                titleFontSize={props.titleFontSize}
                lineHeight={props.height}
            >
                {props.title}
            </Title>
            {props.subtitle && <Title titleFontSize="1.3em">{props.subtitle}</Title>}
        </Header>
    )
}

export default header
